import { Injectable } from '@angular/core';
import { SearchModel } from '@shared/model/search-model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private searchSource = new BehaviorSubject<SearchModel>(new SearchModel());
  currentSearch$ = this.searchSource.asObservable(); 
  constructor() { }

  updateSearch(partial: Partial<SearchModel>) {
    const current = this.searchSource.value;
    this.searchSource.next({ ...current, ...partial });
  }

  resetSearch() {
    this.searchSource.next(new SearchModel());
  }
}
